import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "nonzero",
    d: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    class: "gear-center",
    style: {"fill":"#0d4760","fill-opacity":"1"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "transparent",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": ".2",
    d: "M6.808.38h2.37a.38.38 0 0 1 .366.266l.015.07.228 1.85a5.9 5.9 0 0 1 1.785.974l.22.185-.008.007 1.73-.731a.38.38 0 0 1 .43.094l.05.066 1.188 2.057a.38.38 0 0 1-.04.44l-.06.055-1.485 1.136a5.5 5.5 0 0 1 .052 2.011l-.052.29 1.5 1.135a.38.38 0 0 1 .134.42l-.034.075-1.189 2.057a.38.38 0 0 1-.403.184l-.077-.024-1.737-.731a5.5 5.5 0 0 1-1.775 1.074.38.38 0 0 0-.225.225l-.019.08-.206 1.638a.4.4 0 0 1-.301.327l-.08.008H6.808a.366.366 0 0 1-.355-.266l-.01-.07-.237-1.866v.015a5.7 5.7 0 0 1-1.059-.48 6 6 0 0 1-.726-.494l-.218-.184.007-.007-1.737.731a.38.38 0 0 1-.431-.094l-.049-.066L.805 10.78a.38.38 0 0 1 .04-.44l.059-.055 1.5-1.135a5.6 5.6 0 0 1-.052-2.012l.053-.29L.904 5.714a.39.39 0 0 1-.138-.42l.03-.075 1.19-2.057a.38.38 0 0 1 .403-.184l.076.024 1.738.731a5.5 5.5 0 0 1 1.775-1.074.38.38 0 0 0 .225-.225l.019-.08.205-1.638a.39.39 0 0 1 .311-.328zh2.37zM8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
    class: "gear",
    style: {"fill":"#ee6a28","fill-opacity":"1"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }